import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/fuwu',
    name: 'fuwu',
    component: () => import(/* webpackChunkName: "about" */ '../views/FuWu.vue')
  },
  {
    path: '/dianfan',
    name: 'dianfan',
    component: () => import(/* webpackChunkName: "about" */ '../views/DianFan.vue')
  },
  {
    path: '/langwin',
    name: 'langwin',
    component: () => import(/* webpackChunkName: "about" */ '../views/LangWin.vue')
  },
  {
    path: '/jingpin',
    name: 'jingpin',
    component: () => import(/* webpackChunkName: "about" */ '../views/JingPin.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
